export const footerMoreLinks = {
  'ru-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://ru.wingie.com/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://ru.wingie.com/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://ru.wingie.com/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://ru.wingie.com/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://ru.wingie.com/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://ru.wingie.com/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'ru-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://ru.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ru.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://ru.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://ru.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://ru.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://ru.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'ru-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://ru.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://ru.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://ru.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://ru.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://ru.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://ru.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'ru-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://ru.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://ru.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://ru.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://ru.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://ru.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://ru.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'ru-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://ru.wingie.com/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://ru.wingie.com/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://ru.wingie.com/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://ru.wingie.com/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://ru.wingie.com/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://ru.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'ru-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://ru.wingie.com/it/contact/', title: 'Contatti' },
        // { href: 'https://ru.wingie.com/it/faq/', title: 'Domande frequenti' },

        { href: 'https://ru.wingie.com/it/about-us/', title: 'Chi siamo' },
        { href: 'https://ru.wingie.com/it/privacy/', title: 'Privacy' },
        { href: 'https://ru.wingie.com/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://ru.wingie.com/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'ru-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://ru.wingie.com/fr/contact/', title: 'Contact' },
        // { href: 'https://ru.wingie.com/fr/faq/', title: 'Questions fréquemment posées' },

        { href: 'https://ru.wingie.com/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://ru.wingie.com/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://ru.wingie.com/fr/terms-and-conditions/', title: 'Conditions générales' },
        { href: 'https://ru.wingie.com/fr/awards/', title: 'Nos prix' },
      ],
    },
  ],
  'ru-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://ru.wingie.com/pt/contact/', title: 'Contato' },
        // { href: 'https://ru.wingie.com/pt/faq/', title: 'Perguntas frequentes' },

        { href: 'https://ru.wingie.com/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://ru.wingie.com/pt/privacy/', title: 'Privacidade' },
        { href: 'https://ru.wingie.com/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://ru.wingie.com/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'ru-ro': [
    {
      title: 'Mai mult',
      items: [
        { href: 'https://ru.wingie.com/ro/contact/', title: 'Contact' },
        // { href: 'https://ru.wingie.com/ro/faq/', title: 'Întrebări frecvente' },

        { href: 'https://ru.wingie.com/ro/about-us/', title: 'Despre noi' },
        { href: 'https://ru.wingie.com/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://ru.wingie.com/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://ru.wingie.com/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'ru-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://ru.wingie.com/pl/contact/', title: 'Kontakt' },
        // { href: 'https://ru.wingie.com/pl/faq/', title: 'Często zadawane pytania' },

        { href: 'https://ru.wingie.com/pl/about-us/', title: 'O nas' },
        { href: 'https://ru.wingie.com/pl/privacy/', title: 'Prywatność' },
        { href: 'https://ru.wingie.com/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://ru.wingie.com/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'ru-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://ru.wingie.com/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://ru.wingie.com/lt/faq/', title: 'Dažnai užduodami klausimai' },

        { href: 'https://ru.wingie.com/lt/about-us/', title: 'Apie mus' },
        { href: 'https://ru.wingie.com/lt/privacy/', title: 'Privatumas' },
        { href: 'https://ru.wingie.com/lt/terms-and-conditions/', title: 'Taisyklės ir sąlygos' },
        { href: 'https://ru.wingie.com/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'ru-uz': [
    {
      title: "Ko'proq",
      items: [
        { href: 'https://ru.wingie.com/uz/contact/', title: 'Aloqa' },
        // { href: 'https://ru.wingie.com/uz/faq/', title: "Tez-tez so'raladigan savollar" },

        { href: 'https://ru.wingie.com/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://ru.wingie.com/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://ru.wingie.com/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://ru.wingie.com/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'ru-sr': [
    {
      title: 'Више',
      items: [
        { href: 'https://ru.wingie.com/sr/contact/', title: 'Контакт' },
        // { href: 'https://ru.wingie.com/sr/faq/', title: 'Често постављана питања' },

        { href: 'https://ru.wingie.com/sr/about-us/', title: 'О нама' },
        { href: 'https://ru.wingie.com/sr/privacy/', title: 'Приватност' },
        { href: 'https://ru.wingie.com/sr/terms-and-conditions/', title: 'Услови коришћења' },
        { href: 'https://ru.wingie.com/sr/awards/', title: 'Наша признања' },
      ],
    },
  ],
  'ru-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://ru.wingie.com/ky/contact/', title: 'Байланыш' },
        // { href: 'https://ru.wingie.com/ky/faq/', title: 'Көп берилүүчү суроолор' },

        { href: 'https://ru.wingie.com/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://ru.wingie.com/ky/privacy/', title: 'Купуялык' },
        { href: 'https://ru.wingie.com/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://ru.wingie.com/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'ru-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://ru.wingie.com/tg/contact/', title: 'Алоқа' },
        // { href: 'https://ru.wingie.com/tg/faq/', title: 'Саволҳои зуд-зуд пурсида мешаванда' },

        { href: 'https://ru.wingie.com/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://ru.wingie.com/tg/privacy/', title: 'Махфият' },
        { href: 'https://ru.wingie.com/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://ru.wingie.com/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'ru-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://ru.wingie.com/kk/contact/', title: 'Байланыс' },
        // { href: 'https://ru.wingie.com/kk/faq/', title: 'Жиі қойылатын сұрақтар' },

        { href: 'https://ru.wingie.com/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://ru.wingie.com/kk/privacy/', title: 'Құпиялық' },
        { href: 'https://ru.wingie.com/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://ru.wingie.com/kk/awards/', title: 'Біздің марапаттарымыз' },
      ],
    },
  ],
  'ru-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://ru.wingie.com/nl/contact/', title: 'Contact' },
        // { href: 'https://ru.wingie.com/nl/faq/', title: 'Veelgestelde vragen' },

        { href: 'https://ru.wingie.com/nl/about-us/', title: 'Over ons' },
        { href: 'https://ru.wingie.com/nl/privacy/', title: 'Privacy' },
        { href: 'https://ru.wingie.com/nl/terms-and-conditions/', title: 'Algemene voorwaarden' },
        { href: 'https://ru.wingie.com/nl/awards/', title: 'Onze awards' },
      ],
    },
  ],
  'ru-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://ru.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://ru.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://ru.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://ru.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://ru.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://ru.wingie.com/ja/awards/' },
      ],
    },
  ],
  'ru-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://ru.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://ru.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://ru.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://ru.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://ru.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://ru.wingie.com/zh/awards/' },
      ],
    },
  ],
  'ru-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://ru.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://ru.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://ru.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://ru.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://ru.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://ru.wingie.com/ko/awards/' },
      ],
    },
  ],
  'ru-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://ru.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://ru.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://ru.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://ru.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://ru.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://ru.wingie.com/hi/awards/' },
      ],
    },
  ],
  'ru-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://ru.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://ru.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://ru.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://ru.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://ru.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://ru.wingie.com/ta/awards/' },
      ],
    },
  ],
  'ru-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://ru.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://ru.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://ru.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://ru.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://ru.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://ru.wingie.com/th/awards/' },
      ],
    },
  ],
  'ru-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://ru.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://ru.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://ru.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://ru.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://ru.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://ru.wingie.com/ur/awards/' },
      ],
    },
  ],
  'ru-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://ru.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://ru.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://ru.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://ru.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://ru.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://ru.wingie.com/ka/awards/' },
      ],
    },
  ],
}
